const APP_VERSION = '1784335260271';
export default APP_VERSION;
